import { render, staticRenderFns } from "./ItemManufacturerDataList.vue?vue&type=template&id=c4011134&"
import script from "./ItemManufacturerDataList.vue?vue&type=script&lang=js&"
export * from "./ItemManufacturerDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4011134')) {
      api.createRecord('c4011134', component.options)
    } else {
      api.reload('c4011134', component.options)
    }
    module.hot.accept("./ItemManufacturerDataList.vue?vue&type=template&id=c4011134&", function () {
      api.rerender('c4011134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemManufacturerDataList.vue"
export default component.exports